<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
    <div class="login-page">
      <!-- 背景装饰 -->
      <div class="bg-decor bg-decor-1"></div>
      <div class="bg-decor bg-decor-2"></div>
      <div class="bg-decor bg-decor-3"></div>

      <div class="login-card">
        <!-- 左侧品牌区 -->
        <div class="brand-side">
          <div class="brand-icon">
            <i class="el-icon-food"></i>
          </div>
          <div class="brand-title">菜品数量管理</div>
          <div class="brand-sub">CATERING MANAGEMENT PLATFORM</div>
          <div class="brand-desc">档口菜品余量实时管理<br />售罄一键标记，高效便捷</div>
        </div>

        <!-- 右侧表单区 -->
        <div class="form-side">
          <div class="form-title">欢迎登录</div>
          <div class="form-tip">请输入账号信息开始管理</div>

          <div class="form-item">
            <i class="el-icon-user"></i>
            <input
              v-model="ruleForm.account"
              type="text"
              placeholder="请输入账号"
              autocomplete="off"
            />
          </div>
          <div class="form-item">
            <i class="el-icon-lock"></i>
            <input
              v-model="ruleForm.password"
              type="password"
              placeholder="请输入密码"
              @keyup.enter="submit"
            />
          </div>

          <button class="login-btn" :disabled="loading" @click="submit">
            <i class="el-icon-right" v-if="!loading"></i>
            {{ loading ? "登录中..." : "登 录" }}
          </button>
        </div>
      </div>

      <div class="footer-text">© 2026 数字食堂云平台</div>
    </div>
  </v-scale-screen>
</template>

<script>
import { login } from "../api/api";

export default {
  name: "LoginMenu",
  data() {
    return {
      loading: false,
      ruleForm: {
        account: "",
        password: "",
      },
    };
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (!this.ruleForm.account) {
        this.$message.error("请输入账号！");
        return;
      }
      if (!this.ruleForm.password) {
        this.$message.error("请输入密码！");
        return;
      }
      this.loading = true;
      login(this.ruleForm)
        .then((res) => {
          // code === 0 表示失败（与现有登录逻辑一致）
          if (res.data && res.data.code === 0) {
            this.$message.error(res.data.msg || "登录失败");
            this.loading = false;
            return;
          }
          const userinfo = res.data && res.data.data && res.data.data.userinfo;
          if (userinfo && userinfo.token) {
            sessionStorage.setItem("token", userinfo.token);
          }
          // 店铺 ID 存入本地（优先取 res.data.data.shop_id，兼容 userinfo.shop_id）
          const shopId =
            (res.data.data && res.data.data.shop_id) ||
            (userinfo && userinfo.shop_id);
          if (shopId != null) {
            sessionStorage.setItem("shop_id", shopId);
          }
          this.$message.success("登录成功");
          const redirect = this.$route.query.redirect || "/menuNumC";
          this.$router.replace(redirect);
        })
        .catch(() => {
          this.$message.error("登录失败，请检查网络");
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.login-page {
  width: 1920px;
  height: 1080px;
  position: relative;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  background: linear-gradient(135deg, #0e3d22 0%, #155730 45%, #1e7a45 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 背景装饰圆 */
.bg-decor {
  position: absolute;
  border-radius: 50%;
  opacity: 0.12;
  background: #ffffff;
}

.bg-decor-1 {
  width: 520px;
  height: 520px;
  top: -160px;
  left: -120px;
}

.bg-decor-2 {
  width: 380px;
  height: 380px;
  bottom: -120px;
  right: -80px;
}

.bg-decor-3 {
  width: 160px;
  height: 160px;
  top: 120px;
  right: 220px;
  opacity: 0.08;
}

/* 登录卡片 */
.login-card {
  width: 980px;
  height: 560px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);
  display: flex;
  overflow: hidden;
  z-index: 2;
}

/* 左侧品牌区 */
.brand-side {
  width: 420px;
  flex-shrink: 0;
  background: linear-gradient(160deg, #1e7a45 0%, #155730 100%);
  color: #fff;
  padding: 60px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.brand-icon {
  width: 96px;
  height: 96px;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  margin-bottom: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.brand-title {
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 6px;
  margin-bottom: 14px;
}

.brand-sub {
  font-size: 16px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 40px;
}

.brand-desc {
  font-size: 20px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.85);
}

/* 右侧表单区 */
.form-side {
  flex: 1;
  padding: 60px 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.form-title {
  font-size: 36px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 12px;
  letter-spacing: 2px;
}

.form-tip {
  font-size: 18px;
  color: #909399;
  margin-bottom: 48px;
}

.form-item {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 20px;
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  margin-bottom: 28px;
  transition: border-color 0.2s ease;
  background: #fafbfc;
}

.form-item:focus-within {
  border-color: #155730;
  background: #ffffff;
}

.form-item i {
  font-size: 22px;
  color: #909399;
  margin-right: 14px;
  transition: color 0.2s ease;
}

.form-item:focus-within i {
  color: #155730;
}

.form-item input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 22px;
  color: #303133;
}

.form-item input::placeholder {
  color: #c0c4cc;
}

.login-btn {
  width: 100%;
  height: 64px;
  margin-top: 12px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(90deg, #155730 0%, #1e7a45 100%);
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 10px 24px rgba(21, 87, 48, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-btn:hover {
  opacity: 0.92;
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(21, 87, 48, 0.4);
}

.login-btn:active {
  transform: translateY(0);
}

.login-btn i {
  margin-right: 10px;
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.footer-text {
  position: absolute;
  bottom: 36px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 2px;
  z-index: 2;
}
</style>
